import { ParsedUrlQuery } from 'querystring';

export function getPetsAllowed(query: ParsedUrlQuery) {
    if (query['pets_allowed']) {
        return query['pets_allowed'];
    }

    return '';
}
